<div class="ui-g-12">
  <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/catalog-gift-received-store" label="{{ 'common.back' | translate }}"></button>
  <app-kontable
    #table
    title="{{ 'catalog.reservationCatalogGiftAssigned' | translate }}"
    [columns]="[
      {field: 'reservation_id', title: 'reservations.reservationNumber'},
      {field: 'gift_description', title: 'catalog.gift', bodyTemplate: gift, filterType:selectFilter, filterOptions: {values: giftOption} },
      {field: 'catalog_description', title: 'catalog.catalog', bodyTemplate: catalog, filterType: selectFilter, filterOptions: {values: catalogOption}},
      {field: 'acm_code', title: 'catalog.acm', bodyTemplate: acm, filterType: selectFilter, filterOptions: {values: acmTypes}},
      {field: 'points', title: 'loyalty.points', filterType: noFilter},
      {field: 'contribution', title: 'catalog.contribution', bodyTemplate: contribution, filterType: noFilter},
      {field: 'store_name', title: 'common.store_title', filterType: selectFilter, filterOptions: {values: storeOption}},
      {field: 'cust_card_number', title: 'common.card'},
      {field: 'cust_name', title: 'common.customer', bodyTemplate: customer}

    ]"
    [service]="giftAssignedService"
    [paginationType]="paginationType"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="false"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="false"
    [additionalRowCommands]="customRow"
    [showReport]="true"
  >

  <!-- Template per colonna Gift -->
  <ng-template #gift data-testid="gift" let-row>
    <span >{{row.gift_code + ' - ' + row.gift_description}}</span>
  </ng-template>

  <!-- Template per colonna Catalog -->
  <ng-template #catalog data-testid="catalog" let-row>
    <span>{{row.catalog_code + ' - ' + row.catalog_description}}</span>
  </ng-template>

  <!-- Template per colonna Acm-->
  <ng-template #acm data-testid="acm" let-row>
    <span>{{row.acm_code + ' - ' + row.acm_description}}</span>
  </ng-template>

  <!-- Template per colonna Contribution-->
  <ng-template #contribution data-testid="contribution" let-row>
    <span *ngIf="row.contribution">{{row.contribution.toFixed(2) + '€'}}</span>
  </ng-template>

  <!-- Template per colonna Store-->
  <ng-template #store>
    <span></span>
  </ng-template>

  <!-- Template per colonna Customer -->
  <ng-template #customer data-testid="customer" let-row>
    <span>{{row.cust_surname + ' ' + row.cust_name}}</span>
  </ng-template>

    <!-- Colonna senza filtri -->
    <ng-template #noFilter></ng-template>


    <!-- Bottoni custom -->
    <ng-template #customRow data-testid="customRow" let-row>
      <p-button pTooltip="{{ 'common.info' | translate }}" icon="fa fas fa-info" styleClass="ui-button-info" (onClick)="redirectReservation(row)"></p-button>
    </ng-template>

  </app-kontable>
</div>




// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-assigned/loyalty-catalog-gift-assigned.component.html